import { useMutation } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

// A failed check is not surfaced to the user - it's a soft assist while registering a new
// patient, never a gate on saving, so a network blip here should not alarm or block anyone.
export const useCheckPatientDuplicates = () => {
  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useMutation({
    mutationFn: async ({ firstName, surname, dateOfBirth }) => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.get(
        `${tenantVal}/patient/check-duplicate`,
        { params: { firstName, surname, dateOfBirth: dateOfBirth || undefined } }
      );
      return response.data;
    },
  });
};
